module.exports = __webpack_public_path__ + "img/icon3.dddb13a7.png";